import { createFileRoute } from "@tanstack/react-router";
import { SupplyFamiliesSettingsPage } from "../../../../../pages/organisation-page/organisation-settings-pages";

export const Route = createFileRoute("/_auth/_organisation/organisation/resources/supply-families")({
  component: SupplyFamiliesSettingsPage,
});
